<script setup lang="ts">
import { formatPlatformName } from '@/lib/utils'

defineProps<{
  code: string
  name?: string
}>()
</script>

<template>
  <UBadge color="neutral" variant="outline" size="sm">
    {{ formatPlatformName(name || code) }}
  </UBadge>
</template>
